const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

if (!reducedMotion.matches && 'IntersectionObserver' in window && Element.prototype.animate) {
  const mobile = window.matchMedia('(max-width: 749px)');
  const animations = new Set();
  const initialized = new WeakSet();
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!initialized.has(entry.target)) {
        initialized.add(entry.target);
        if (entry.boundingClientRect.height > 0 && entry.boundingClientRect.top < window.innerHeight) {
          observer.unobserve(entry.target);
          continue;
        }
      }
      if (!entry.isIntersecting || entry.intersectionRatio < 0.8) continue;
      observer.unobserve(entry.target);
      if (reducedMotion.matches || document.hidden) continue;

      const animation = entry.target.animate(
        [{ translate: `0 ${mobile.matches ? 5 : 8}px` }, { translate: '0 0' }],
        { duration: mobile.matches ? 520 : 650, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
      animations.add(animation);
      animation.finished.then(() => animations.delete(animation), () => animations.delete(animation));
    }
  }, { threshold: 0.8, rootMargin: '0px 0px -12% 0px' });

  for (const section of document.querySelectorAll('#MainContent [data-ch-heading-motion]')) {
    const heading = section.querySelector('h2, h3');
    if (heading) observer.observe(heading);
  }

  reducedMotion.addEventListener('change', () => {
    observer.disconnect();
    for (const animation of animations) animation.cancel();
    animations.clear();
  }, { once: true });
}
